/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable max-len */
import {
  Icon,
  Input,
  ShortText,
} from 'components/common';
import Layout from 'components/layout/Layout';
import { css } from '@emotion/react';
import colors from 'config/color';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import api from 'api';
import * as styles from '../../components/pages/Candidates/[candidateId]/CandidateDetails/EducationSection/AddEducationModal/AddEducationModal.styles';

const Attestation = () => {
  const { candidateId, token } = useParams();
  const [data, setData] = useState(null);

  const isSigned = data?.attestation_status?.toLowerCase() === 'signed';
  const fetchAttestationDetail = async () => {
    const { data: attestationData } = await api.getAttestationByToken(candidateId, token);
    setData(attestationData.data);
  };

  useEffect(() => {
    if (candidateId && token) {
      fetchAttestationDetail(candidateId, token);
    }
  }, [candidateId, token]);

  const formatDate = (dateString) => new Date(dateString).toLocaleDateString('id-ID', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });

  const formatDateTime = (dateString) => {
    const date = new Date(dateString);

    const day = date.toLocaleDateString('en-US', { weekday: 'short' });
    const dayNum = date.getDate();
    const month = date.toLocaleDateString('en-US', { month: 'short' });
    const time = date.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
    });

    return `${day} ${dayNum} ${month} at ${time}`;
  };

  // formatDateTime("2026-03-30T14:41:26+07:00") => "Sun 30 Mar at 14:41:26"

  const getEmploymentLabel = (code) => {
    const options = [
      {
        label: '(1A) Bekerja sebagai karyawan tetap (full-time employee) : kontrak kerja lebih dari ≥ 6 bulan',
        value: '1A',
      },
      {
        label: '(1B) Bekerja sebagai magang, apprenticeship, atau kontrak : kontrak kerja 3-6 bulan dengan potential full-time position',
        value: '1B',
      },
      {
        label: '(1C) Bekerja sebagai freelance, paruh waktu, kontrak jangka pendek, atau durasi tidak ditentukan : kontrak kerja kurang dari 3 bulan',
        value: '1C',
      },
      {
        label: '(1D) Mendirikan dan/atau menjalankan usaha atau venture',
        value: '1D',
      },
      {
        label: '(2A) Bekerja di bidang di luar program yang saya ikuti',
        value: '2A',
      },
      {
        label: '(2B) Melanjutkan Pendidikan ke jenjang atau institusi lain',
        value: '2B',
      },
      {
        label: '(2C) Tidak sedang mencari pekerjaan karena alasan pribadi, keluarga, atau kesehatan',
        value: '2C',
      },
    ];

    return options.find((opt) => opt.value === code)?.label ?? null;
  };

  // getEmploymentLabel("1D") => "(1D) Mendirikan dan/atau menjalankan usaha atau venture"
  // getEmploymentLabel("1A") => "(1A) Bekerja sebagai karyawan tetap..."
  // getEmploymentLabel("XYZ") => null

  // formatDate("2023-04-13T07:00:00+07:00") => "13 April 2023"

  /* -------------------- CSS -------------------- */

  const inputStyles = css`
    width: calc(100% - 24px);
    padding: 12px;
    border: 1px solid ${colors.GREY};
    background: ${colors.WHITE};
    border-radius: 8px;
    font-size: 16px;
    height: 22px;
    border-outline: none;

    &:disabled {
      cursor: not-allowed;
    }
  `;

  /* -------------------- CONSTANT STYLES -------------------- */

  const fieldWrapper = { display: 'flex', flexDirection: 'column', gap: 6 };

  const gridTwo = {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: '24px',
  };

  const gridThree = {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: '24px',
  };

  const uploadBox = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '8px 0 0 0',
    padding: '30px',
    border: `1px solid ${colors.GREY}`,
    borderRadius: '5px',
    cursor: 'pointer',
  };

  /* -------------------- STATE -------------------- */

  const [, setFormData] = useState({});

  /* -------------------- HANDLERS -------------------- */

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleDownload = (url) => {
    const link = document.createElement('a');
    link.href = url;
    link.download = url.split('/').pop();
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  /* -------------------- RENDER -------------------- */

  if (!data) {
    return (
      <div style={{
        padding: 32, display: 'flex', justifyContent: 'center', alignItems: 'center'
      }}
      >
        Loading...
      </div>
    );
  }

  return (
    <Layout>
      <div style={{
        padding: 32, display: 'flex', justifyContent: 'center', alignItems: 'center'
      }}
      >
        <div
          style={{
            padding: 48,
            backgroundColor: 'white',
            width: '100%',
            borderRadius: '12px',
            maxWidth: '905px',
            display: 'flex',
            flexDirection: 'column',
          }}
        >

          <div style={{ display: 'flex', flexDirection: 'column', gap: 24 }}>

            <ShortText styles={{ color: '#1D3D71', fontSize: '20px', fontWeight: 600 }}>
              Attestation Submission
            </ShortText>

            {/* GRID 2 */}
            <div style={{ ...gridTwo, marginTop: 16 }}>
              <div style={fieldWrapper}>
                <ShortText styles={styles.labelStyles}>Nama Lengkap</ShortText>
                <Input disabled type="text" name="name" styles={inputStyles} className="disabled" value={data?.full_name} />
              </div>

              <div style={fieldWrapper}>
                <ShortText styles={styles.labelStyles}>Status Kewarganegaraan</ShortText>
                <Input disabled type="text" name="name" styles={inputStyles} className="disabled" value={data?.citizenship_status} />
              </div>
            </div>

            {/* GRID 2 */}
            <div style={gridTwo}>
              <div style={fieldWrapper}>
                <ShortText styles={styles.labelStyles}>email</ShortText>
                <Input disabled type="text" name="email" styles={inputStyles} placeholder="johndoe@gmail.com" value={data?.email} />
              </div>

              <div style={fieldWrapper}>
                <ShortText styles={styles.labelStyles}>No HP</ShortText>
                <Input disabled type="number" name="phoneNumber" styles={inputStyles} placeholder={data?.phone_number} />
              </div>
            </div>

            {/* GRID 3 */}
            <div style={gridThree}>
              <div style={fieldWrapper}>
                <ShortText styles={styles.labelStyles}>Kode Program</ShortText>
                <Input disabled type="text" name="code" styles={inputStyles} placeholder="FSJS" value={data?.program_code} />
              </div>

              <div style={fieldWrapper}>
                <ShortText styles={styles.labelStyles}>Batch</ShortText>
                <Input disabled type="text" name="batch" styles={inputStyles} placeholder="FSJS-RMT-020" value={data?.batch_code} />
              </div>

              <div style={fieldWrapper}>
                <ShortText styles={styles.labelStyles}>Tanggal Kelulusan</ShortText>
                <Input disabled type="text" styles={inputStyles} placeholder="29 Desember 2025" value={formatDate(data?.graduation_date)} />
              </div>
            </div>

            {/* GRID 4 */}
            <div style={{ display: 'flex', gap: '24px' }}>
              <div style={fieldWrapper}>
                <ShortText styles={styles.labelStyles}>Attestation Status</ShortText>
                <Input
                  className="disabled capitalize"
                  type="text"
                  name="code"
                  styles={inputStyles}
                  placeholder="Hired"
                  disabled
                  value={data?.attestation_type}
                />
              </div>

              <div style={{ ...fieldWrapper, flex: 1 }}>
                <ShortText styles={styles.labelStyles}>Nama Perusahaan/Institusi</ShortText>
                <Input
                  type="text"
                  name="companyName"
                  styles={inputStyles}
                  onChange={handleChange}
                  placeholder="Nama Perusahaan"
                  value={data?.company_name}
                  disabled
                />
              </div>
            </div>

            {/* GRID 5 */}
            <div style={fieldWrapper}>
              <ShortText styles={styles.labelStyles}>
                Aktifitas Profesional Setelah Kelulusan
              </ShortText>
              <Input
                className="disabled capitalize"
                type="text"
                name="code"
                styles={inputStyles}
                disabled
                value={getEmploymentLabel(data?.professional_activity)}
              />
            </div>

            {/* GRID 6 */}
            <div style={gridTwo}>
              <div style={fieldWrapper}>
                <ShortText styles={styles.labelStyles}>Posisi/Peran/Jabatan</ShortText>
                <Input
                  type="text"
                  name="position"
                  styles={inputStyles}
                  placeholder="Frontend Developer"
                  value={data?.job_role}
                  onChange={handleChange}
                  disabled
                />
              </div>

              <div style={fieldWrapper}>
                <ShortText styles={styles.labelStyles}>Tanggal Mulai Bekerja/Usaha</ShortText>
                <Input
                  type="text"
                  name="dateFrom"
                  value={formatDate(data?.start_working_date)}
                  onChange={handleChange}
                  styles={inputStyles}
                  disabled
                />
              </div>
            </div>

            {/* GRID 7 */}
            <div style={gridTwo}>
              <div style={fieldWrapper}>
                <ShortText styles={styles.labelStyles}>Industri/Bidang Usaha</ShortText>
                <Input
                  type="text"
                  name="industry"
                  styles={inputStyles}
                  value={data?.field_of_work}
                  onChange={handleChange}
                  placeholder="Financial Services"
                  disabled
                />
              </div>

              <div style={fieldWrapper}>
                <ShortText styles={styles.labelStyles}>
                  Gaji/Penghasilan (Gross) (IDR)
                </ShortText>
                <Input
                  placeholder={10000000}
                  type="number"
                  name="salary"
                  value={data?.salary_gross}
                  disabled
                  onChange={handleChange}
                  styles={inputStyles}
                />
              </div>
            </div>

            {/* FILE UPLOAD */}

            <div style={{ display: 'flex', flexDirection: 'column', marginTop: 4 }}>
              <ShortText styles={styles.labelStyles}>
                Upload Kontrak Kerja/Surat Konfirmasi Pekerjaan (Optional)
              </ShortText>
              <div style={uploadBox}>
                <div
                  style={{
                    display: 'flex', flexDirection: 'column', gap: 2, justifyContent: 'center', alignItems: 'center'
                  }}
                  onClick={() => {
                    if (data?.proof_file_s3) {
                      handleDownload(data?.proof_file_s3);
                    }
                  }}
                >
                  <Icon
                    style={{
                      display: 'block',
                      margin: '0 6px 0 0',
                      fontSize: '16px',
                      color: colors.PRIMARY_BLUE,
                    }}
                    name="image"
                  />
                  {data?.proof_file_s3 ? 'Download File' : 'No File Added'}
                </div>
              </div>
            </div>

            {isSigned && data?.full_name && data?.attestation_date && (
              <div css={styles.signedInfoContainerStyles}>
                <ShortText styles={styles.signedTextStyles}>
                  {`Signed by ${data?.full_name} ${formatDateTime(data?.attestation_date)}`}
                </ShortText>
              </div>
            )}
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Attestation;
